import { api, deviceId } from "@/lib/api";

const BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

// POST to an SSE endpoint and call onDelta for each streamed text chunk.
export const streamSSE = async (path, body, onDelta) => {
  const send = () => fetch(`${BASE}${path}`, {
    method: "POST", credentials: "include",
    headers: { "Content-Type": "application/json", "X-Device-Id": deviceId() },
    body: JSON.stringify(body || {}),
  });
  let res = await send();
  if (res.status === 401) { await api.post("/auth/refresh").catch(() => {}); res = await send(); }
  if (!res.ok) { const d = await res.json().catch(() => ({})); throw new Error(d.detail || "The AI is unavailable right now."); }
  const reader = res.body.getReader();
  const dec = new TextDecoder();
  let buf = "";
  for (;;) {
    const { done, value } = await reader.read();
    if (done) break;
    buf += dec.decode(value, { stream: true });
    const events = buf.split("\n\n");
    buf = events.pop();
    for (const ev of events) {
      const data = ev.replace(/^data: /, "");
      if (data === "[DONE]") return;
      const j = JSON.parse(data);
      if (j.error) throw new Error(j.error);
      if (j.delta) onDelta(j.delta);
    }
  }
};
